var map = {
	"./Abi.svg": 60372,
	"./article-create.svg": 76337,
	"./article-ranking.svg": 70277,
	"./article.svg": 14748,
	"./change-theme.svg": 86998,
	"./chart.svg": 54310,
	"./close.svg": 92750,
	"./dashboard.svg": 62498,
	"./example.svg": 21048,
	"./exit-fullscreen.svg": 81076,
	"./eye-open.svg": 84674,
	"./eye.svg": 60605,
	"./fullscreen.svg": 59249,
	"./guide.svg": 67706,
	"./hamburger-closed.svg": 8852,
	"./hamburger-opened.svg": 37551,
	"./international.svg": 19430,
	"./introduce.svg": 31637,
	"./language.svg": 24180,
	"./link.svg": 95594,
	"./nested.svg": 46211,
	"./password.svg": 77993,
	"./permission.svg": 56819,
	"./personnel-info.svg": 83987,
	"./personnel-manage.svg": 48414,
	"./personnel.svg": 52050,
	"./reward.svg": 58387,
	"./role.svg": 29338,
	"./search.svg": 38898,
	"./table.svg": 81958,
	"./tree.svg": 53366,
	"./user.svg": 24067,
	"./xinghuo.svg": 78789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;